<script setup>
const route = useRoute()

const data = reactive({
  loading: false
})

const { data: posts, refresh } = await useFetch(`/api/source/posts/${route.params.id}`, { key: `sp${route.params.id}` })
const { data: source } = await useFetch(`/api/source/${route.params.id}`, { key: `s${route.params.id}` })


const infiniteScrolling = async (isIntersecting) => {
  if (isIntersecting && posts.value.length) {
    data.loading = true
    const ret = await $fetch(`/api/source/posts/${route.params.id}?after=${posts.value[posts.value.length-1].date}`)
    if (ret?.length) {
      posts.value.push(...ret)
    }
    data.loading = false
  }
}

const selectedPost = ref({})
const editPostDialog = ref()
function editPost(post) {
  editPostDialog.value.open(post)
}

</script>

<template>
  <v-container>
    <h2>{{$t('Source')}} - <a :href='source?.link'>{{source?.name}}</a></h2>
    <EditPost ref="editPostDialog" :post="selectedPost" @update="refresh"/>
    <p>{{source?.description}}</p>
    <section class='container max-w-80 postContainer'>
      <Post v-for='post in posts'
        card
        :key='post.id'
        :post='post'
        @edit="editPost"
        @remove="posts.splice(id, 1)"
        @toggleVisibility="post.visible = !post.visible"
      />
    </section>
    <div class='ma-12 text-center' v-intersect="infiniteScrolling">
      <v-progress-circular v-if='data.loading' indeterminate />
    </div>
  </v-container>
</template>
